import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	width: 100%;
	background: ${({ theme }) => theme.colors.brand.primary.main};
	border-radius: 8px;
	overflow: hidden;
	font-family: 'Noto Sans', sans-serif;
	margin-bottom: 16px;
`;

export const Bubble = styled.img.attrs({
	src: '/media/gamification/mgm/bubble.png',
	alt: '',
	'aria-hidden': true,
})`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center;
	pointer-events: none;
	opacity: 0.9;
	z-index: 0;
`;

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 14px 16px;
`;

export const Title = styled.h3`
	margin: 0;
	color: #ffffff;
	font-size: 15px;
	font-weight: 700;
	line-height: 1.25;
`;

export const LinkRow = styled.div`
	display: flex;
	gap: 6px;
	margin-top: 2px;
`;

export const LinkInput = styled.input`
	flex: 1;
	min-width: 0;
	padding: 8px 10px;
	border: none;
	border-radius: 6px;
	background: #ffffff;
	font-size: 12px;
	color: #7e8299;
	font-family: inherit;
	outline: none;
	text-overflow: ellipsis;
`;

export const CopyButton = styled.button`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 8px 12px;
	background: #ffffff;
	border: none;
	border-radius: 6px;
	font-size: 12px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.black.quaternary};
	cursor: pointer;
	font-family: inherit;
	white-space: nowrap;
	transition: background 0.2s;

	&:hover {
		background: ${({ theme }) => theme.colors.gray.tredecimal};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.colors.white.primary};
		outline-offset: 2px;
	}
`;

export const Footer = styled.div`
	display: flex;
	justify-content: space-between;
	gap: 8px;
`;

export const FooterText = styled.span`
	color: ${({ theme }) => theme.colors.white.primary};
	font-size: 11px;
	font-weight: 500;
	opacity: 0.9;
`;
